import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cc-web-v4/components/cryptoread/CRFooter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cc-web-v4/components/cryptoread/CRUser.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cc-web-v4/components/cryptoread/header/CRHeaderLogo.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cc-web-v4/components/cryptoread/header/CRNavFunction.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cc-web-v4/components/cryptoread/modals/CRModals.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/styles/cryptoread.scss");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/styles/global.scss");
